export default __webpack_public_path__ + "static/media/abstract1.e4ad24e4.png";